var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 315.13 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.59 250H96a5.53 5.53 0 0 1-2.88-.82L15.9 201.5a5.49 5.49 0 0 1 2.88-10.16H232.4a5.56 5.56 0 0 1 2.89.82l77.18 47.65a5.49 5.49 0 0 1-2.88 10.19ZM97.52 239h192.73l-59.4-36.67H38.11ZM296.29 58.63H82.67a5.5 5.5 0 0 1-2.88-.82L2.6 10.16A5.49 5.49 0 0 1 5.49 0h213.62a5.5 5.5 0 0 1 2.89.82l77.18 47.65a5.49 5.49 0 0 1-2.88 10.16Zm-212.06-11H277L217.55 11H24.82ZM187 101.16a33.4 33.4 0 0 0-23.53-9.62h-.35a33.64 33.64 0 0 0 .33 67.28h.34A33.64 33.64 0 0 0 187 101.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterlayLogo);
export default __webpack_public_path__ + "static/media/interlay-logo.016fac7f.svg";
export { ForwardRef as ReactComponent };